import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import CompletedActivity from './LevelActivity'
import SectionHeader from 'app/components/SectionHeader'
import FavoriteActivitiesLoader from 'app/domains/common/Loaders/FavoriteActivitiesLoader'
import NoCompletedActivities from 'app/components/NoActivitiesComponent'
import './style.scss'

const baseClass = 'completed-level-activities'

class LevelActivities extends Component {
  static propTypes = {
    match: PropTypes.object,
    activitiesList: ImmutablePropTypes.list.isRequired,
    pending: PropTypes.bool,
    getCompletedActivities: PropTypes.func.isRequired,
    removeActivityFromFavorites: PropTypes.func,
  }

  componentDidMount() {
    const { match, getCompletedActivities } = this.props
    getCompletedActivities(match.params.protrackId)
  }

  render() {
    const { t, activitiesList, pending, level, removeActivityFromFavorites, addActivityToFavorites } = this.props
    const name = level && level.get('name')
    const proTrackName = level && level.get('proTrackName')
    return (
      <div className={baseClass}>
        <SectionHeader className={`section-header--${baseClass}`} backHref title={`${proTrackName} (${name})`} />
        <div className={`${baseClass}__body`}>
          {pending ? (
            <FavoriteActivitiesLoader />
          ) : activitiesList.size ? (
            activitiesList.map((activity, index, activities) => {
              if (!index) {
                return (
                  <Fragment key={activity.activityId}>
                    <CompletedActivity date={activity.updatedAt} first completedActivity={activity.content} />
                    <CompletedActivity
                      date={activity.updatedAt}
                      actionType={activity.actionType}
                      completedActivity={activity.content}
                      removeActivityFromFavorites={removeActivityFromFavorites}
                      addActivityToFavorites={addActivityToFavorites}
                      previousActionType={activity.previousActionType}
                    />
                  </Fragment>
                )
              }
              return (
                <CompletedActivity
                  key={activity.activityId}
                  date={activity.updatedAt}
                  actionType={activity.actionType}
                  last={activities.size === index + 1}
                  completedActivity={activity.content}
                  removeActivityFromFavorites={removeActivityFromFavorites}
                  addActivityToFavorites={addActivityToFavorites}
                  previousActionType={activity.previousActionType}
                />
              )
            })
          ) : (
            <NoCompletedActivities
              topText={t('This Level is not complete yet')}
              bottomText={t('You can complete this Level by going through all the activities')}
              customClass="completed-protracks"
            />
          )}
        </div>
      </div>
    )
  }
}

export default LevelActivities
